import { StyleSheet } from "aphrodite";
import colors from "../../styles/colors";

export default StyleSheet.create({
  loginForm: {
    margin: "auto",
    maxWidth: "300px"
  },
  loginFormForgot: {
    float: "right"
  },
  loginFormButton: {
    width: "100%",
    backgroundColor: colors.pink
  },
  errorWrap: {
    position: "relative",
    height: "30px",
    textAlign: "center"
  },
  error: {
    margin: "0px"
  }
});
